<template>
  <div>
    <!-- Trilha de Auditoria -->
    <div class="panel panel-default" v-if="detalhesEnvioEntrega && detalhesEnvioEntrega.trilhaAuditoria">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Trilha de Auditoria</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">
          <pre class="carimbo">{{ detalhesEnvioEntrega.trilhaAuditoria }}</pre>
        </li>
      </ul>
    </div>

    <!-- Hash Assinado -->
    <div class="panel panel-default" v-if="detalhesEnvioEntrega && detalhesEnvioEntrega.hashAssinado">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Hash Assinado</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">
          <strong>{{ detalhesEnvioEntrega.hashAssinado }}</strong>
        </li>
      </ul>
    </div>

    <!-- Carimbo do Tempo -->
    <div class="panel panel-default" v-if="detalhesEnvioEntrega && detalhesEnvioEntrega.carimbo">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Carimbo do Tempo (Entrega)</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item" v-if="detalhesEnvioEntrega.ocorridoEm">
          Ocorrido em: <strong>{{ detalhesEnvioEntrega.ocorridoEm }}</strong>
        </li>
        <li class="list-group-item">
          <pre id="carimbo" style="margin-top: 10px;">{{ detalhesEnvioEntrega.carimbo }}</pre>
        </li>
        <li class="list-group-item">
          Certificado pela Autoridade do Carimbo do tempo ICP-Brasil
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailBrySendDeliveryDetails',

  props: {
    detalhesEnvioEntrega: {
      type: Object
    }
  },

  computed: {
    timestampAuthorityName () {
      const emitidoPor = this.detalhesEnvioEntrega && this.detalhesEnvioEntrega.emitidoPor
      if (emitidoPor === 'SAFEWEB') {
        return 'SAFEWEB'
      }
      return 'Bry Tecnologia'
    },

    timestampAuthorityUrl () {
      const emitidoPor = this.detalhesEnvioEntrega && this.detalhesEnvioEntrega.emitidoPor
      if (emitidoPor === 'SAFEWEB') {
        return 'https://www.safeweb.com.br/'
      }
      return 'https://www.bry.com.br/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-bry/InfoEmailBrySendDeliveryDetails.vue